import { LOCALES } from "../locales";

export default {
  [LOCALES.SPANISH]: {
  // general product translation 
  January:"january",
  February:"february",
  March:"march",
  April:"april",
  May:"may",
  June:"june",
  July:"july",
  August:"august",
  September:"september",
  October:"october",
  November:"november",
  December:"december",
    class_policy: "Class Policy",
    Faq: "FAQs",
    help: "Help",
    frequently_asked_ques: "Frequently Asked Questions",
    customer_support: "Customer Support",
    user_name: "User name",
    password: "Password",
    email_address: "Email address",
    // Header Translations
    notification: "Notification",
    page_loading_aria: "Page is loading",
    state_loading_aria: "State is loading",
    city_loading_aria: "City is loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Overall badge",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Certificate image",
    certificate_download: "Download certificate button",
    prev: "Previous",
    log_out: "Log out",
    // feature names
    feature_progress: "Progress",
    feature_stressAndIntonation_title:"Stress and intonation",
    feature_soundOfEnglish_title:"Sounds of english",
    feature_vocabularyCenter_title: "Vocabulary center",
    feature_grammarCenter_title:"Grammar center",
    feature_cultureNotes_title: "Culture notes",
    feature_globalCommunityTutorials_title:"Global community tutorials",
    feature_industryfeed_title: "Industry feed",    
    feature_newsfeed_title: "News feed",
    feature_emailTemplates_title: "Email templates",
    feature_talkWithTeacher_title : "Talk with teacher",
    feature_accentsAndDialects_title: "Accents and dialects",
    feature_writingCenter_title: "Writing center",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "About",
    legal: "Legal",
    privacy_policy: "Privacy policy",
    Terms_conditions: "Terms and conditions",
    //button translations
    button_continue: "Continuar",
    button_KnowMore: "Know more",
    button_BuyNow: "Buy Now",
    button_Subscribe: "Subscribe",
    button_GetStarted: "Get started",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "View Details",
    button_ContinueStudying: "Continue",
    button_next: "Siguiente",
    button_confirm: "Confirm",
    // cookie policy
    common_cookiesPolicyText1: "By continuing to use this site, you agree to the use of cookies to provide you with better services. Read our",
    common_cookiesPolicyText2: "cookies policy",
    // EO cookie policy    
    //login-page-translations//
    login_welcome: "Welcome",
    login_heloo: "Hello again",    
    login_welcome_text: "Let's get started.",
    login_log_in: "Log in",
    login_errorIncorrectCreds: "Username or password incorrect",
    login_errorContactAmin: "Your account is not active. Contact your administrator.",
    login_errorSSOuser: "You must log in from your company's learning portal.",
    login_resetPasswordTitle: "Reset Password",
    login_resetConfirmText: "Confirm",
    login_resetSuccess: "We’ve sent you an email containing a link that will allow you to reset your password.",
    login_resetFailure: "Email Address is incorrect",
    // common translations
    message_errorDefault: "Something went wrong",
    message_successUpdated: "Updated successfully",
    message_unknownError: "Unknown error",
    message_unAuthorized: "You are not authorized to access this page",
    message_passwordUpdated: "Password updated successfully",
    message_profileUpdated: "Profile updated successfully",
    message_welcomeSubmitted: "Submitted successfully",
    message_samepasswordError: "Enter a new password, please make sure its not a previously used one.",
    SAR: "Seleccione una zona",
    SAL: "Seleccione una ubicación",
    SAT: "Elija un tema",
    link_readmore: "Read more",
    //--//
    profile_title: "Perfil",
    profile_nameLabel: "Me llamo: ",
    profile_countryLabel: "País",
    profile_stateLabel: "State / Province / Region",
    profile_cityLabel: "Ciudad",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Preferred contact",
    profile_prefSkypeLabel: "Skype (Personal) ID",
    profile_prefMobileLabel: "Mobile number",
    profile_prefLandlineLabel: "Landline number",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "I accept and agree to the terms and conditions",
    profile_continueAria: "Continue button",
    profile_TermsAria: "accept terms and conditions",
    profile_stateTooltip: "Your timezone will help us to schedule your online sessions",
    profile_cityTooltip: "If you dont live in one of the cities shown here, please pick the one closest to you",
    profile_emailTooltip: "Verify your email",
    profile_prefTooltip: "All your sessions will take place in the virtual classroom, even if you specified a different contact method in the on-boarding process. We ask you about your preferred contact method for internal use only so that we can continually improve your learning experience.",
    profile_fnamePlaceholder: "Nombre",
    profile_lnamePlaceholder: "Apellidos",
    profile_countryPlaceholder: "Elija un país",
    profile_prefContactSelect: "Select your preference",
    profile_statePlaceholder: "Select a state",
    profile_cityPlaceholder: "Select a city",
    profile_emailInvalidMessage: "Email Address is invalid",
    profile_prefContactPlaceholder: "Choose your preference",
    profile_prefSkypePlaceholder: "Skype (Personal)",
    profile_emailVerifiedChip: "Verified",
    profile_emailVerifyChip: "Verify",
    profile_emailpopup_head: "Enter verification code",
    profile_emailpopup_resendText: "Resend code",
    profile_emailpopup_resendMessage: "Didn't receive the code?",
    profile_invalidNumber: "Invalid number",
    profile_prefSkypeAria: "Preferred Contact as Skype (Personal) ID",
    profile_prefMobileAria: "Preferred Contact as Mobile",
    profile_prefLandlineAria: "Preferred Contact as Landline",
    profile_emailpopup_incorrectCode: "Invalid code",
    profile_editLabel: "Edit profile",
    profile_editAria: "Edit button",
    profile_mainPasswordPlaceholder: "Enter password here",
    profile_updateLabel: "Actualizar",
    profile_welcomeJumbotron: "Bienvenidos",
    profile_cancelLabel: "Cancelar",
    noAccessl1: "Oops! You don't have permission to view this page!",
    noAccessl2: "Here's a link back to the",
    noAccessl2_1: "homepage",
    noAccessl3: "Please contact your Learnship Administrator for help.",
    profile_changepass_changepassHead: "Change password",
    profile_changepass_currentpassword: "Current password",
    profile_changepass_currentpasswordPlaceholder: "Enter current password",
    profile_changepass_newpassword: "New password",
    profile_changepass_newpasswordPlaceholder: "Enter new password",
    profile_changepass_confirmnewpassword: "Confirm new password",
    profile_changepass_confirmnewpasswordPlaceholder: "Enter Confirm new password",
    profile_passMustInclude: "Your password must include:",
    profile_passdontmatch: "Passwords don't match",
    profile_incorrectPassword: "Incorrect password",
    profile_passwordSubmit_title: "Enter password",
    profile_changepass_conditionLength: "Between 8 to 32 characters",
    profile_changepass_conditionUppercase: "At least one uppercase letter",
    profile_changepass_conditionLowercase: "At least one lowercase letter",
    profile_changepass_conditionSpecialCharacters: "At least one digit or one of these symbols $!#&@?%*_",
    profile_translationLanguage: "Traducir",
    profile_translationLanguagePlaceholder: "Choose a language",
    profile_managerEmailPlaceholder: "Manager email",
    profile_managerEmailpopupPlaceholder: "Manager’s email address", 
    // Learner Home Page translations
    learnerhome_survey_header: "We need your feedback!",
    learnerhome_survey_line1: "Your company wants to know about your experience using our service.",
    learnerhome_survey_line2: "Please complete our survey by",
    learnerhome_survey_line3: "Your feedback is very important and greatly appreciated.",
    learnerhome_survey_button1: "Take survey",
    learnerhome_survey_button2: "Skip survey",
    active_course: "Active course",
    admin_header: "Administration",
    get_startedText: "Click on a course below to get started.",
    product_solo_desc: "Learnship SoloTM, our e-learning product, provides everything learners need to practice and improve their business language skills at their own pace.",
    product_conversationPractice_desc: "Learners can book one-on-one sessions with trainers to ask questions, discuss a particular issue or role play scenarios. Useful for more experienced learners looking to finesse their skills.",
    product_sprint_businessSkills_desc: "This next-generation blended learning program helps learners develop specific business skills—presenting, negotiating, business writing and meeting participation—in record time.",
    product_sprint_levelsProgress_desc: "Our next-generation blended language program helps your people rapidly improve their English language skills against a standardized framework.",
    product_evolve_relocationLanguage_desc: "Our employee relocation program helps learners develop a deeper understanding of the language and social nuances of their new country of residence.",
    product_evolve_culturePowerSkills_desc: "Give your employees the cross-cultural skills they need to thrive in international working environments and global virtual teams.",
    product_evolve_cultureFocus_desc: "Country-specific training and cultural-intelligence for learners who need to gain a better understanding of a specific region and its working culture.",
    product_evolve_cultureChange_desc: "This is our premier intercultural business training program for expats. It gives learners an in-depth understanding of what it takes to live and work in a new culture.",
    product_elevate_businessSkills_desc: "Short, standardized training modules for language learners who want to improve specific business skills such as presenting, negotiating or team leadership. We also offer specialist courses focused on industry-specific dialects.",
    product_elevate_levelsProgress_desc: "This trainer-led business language course helps learners improve their written and verbal skills against a standardized framework.",
    product_coach_languageCoach_desc: "Communicate confidently and clearly in boardrooms, emails, negotiations and even around the watercooler. Our one-on-one, hyper-specific executive language coaching helps you master the most important business scenarios. Develop your verbal, written, meeting and personal communication skills.",
    product_coach_cultureCoach_desc: "A hyper-focused, one-on-one coaching program for executives looking to solve specific cross-cultural communication problems.",
    product_solo_business_english : "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german :"A multi-level learning program with engaging online exercises to develop your knowledge and application of Business German at your own pace.",
    product_solo_business_french : "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business French at your own pace.",
    product_solo_business_spanish : "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business Spanish at your own pace.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc: "This is your gateway to Dashboard - an intuitive interface that allows administrators to track usage, analyze learner progress, optimize programs and evaluate ROI.",
    product_elevate_desc:"Elevate program Levels Progress our online business language training for learners who want to develop and improve their language skills against a standardized framework.",
    product_lorem_solo_desc: "This rich multimedia program helps your people rapidly improve their English language skills against a standardized framework.",
    //feature translations
    feature_cultureNotes_desc: "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    feature_emailTemplates_desc: "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    feature_newsFeed_desc: "Welcome to witness a news reading and English learning experience where content and questions are generated live, which gives you access to world news and helps you to enhance your English.",
    feature_talkWithTeacher_desc : "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc: "The Industry Feed combines a library of industry-specific articles with AI-powered language exercises. Choose an article along with a grammar point you want to practice…",
    feature_accentsAndDialects_desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui.",
    feature_accentsAndDialects:"Explore the richness of global English usage through our library of regional speech samples.",
    feature_stressAndIntonation_desc: "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",
    feature_soundOfEnglish_desc: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    feature_vocabularyCenter_desc: "Without grammar, very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
    feature_grammarCenter_desc: "The Grammar Center will help you use correct grammar in your speaking and writing. It includes grammar topics, such as basic sentence parts, verbs and verb forms, and sentences and clauses.",
    feature_globalCommunityTutorials_desc: "Improve your English language skills with this growing collection of community-developed lessons.",
    feature_toeic_desc: "The TOEIC® test is the instrument most widely used by multinational corporations to measure employees’ English proficiency. The TOEIC® uses authentic written materials and dialogue to assess your business English skills.",
    feature_toefl_desc: "TOEFL®, the Test of English as a Foreign Language, is used worldwide by colleges and universities, government agencies, and scholarship programs to evaluate English proficiency.",
    feature_businessSituations_desc: "The Business Situations Index makes it easy for you to find specific activities so that you can focus on the language you need to communicate in a variety of business situations.",
    //carousel block translations
    title_feature: "Features",
    we_recommend: "We also recommend",
    // session report translations
    SessionReport_sessionReport: "Informe de Sesión",
    SessionReport_sessionDetails: "Details",
    SessionReport_teacherName: "Teacher name",
    SessionReport_sessionReview: "Session review",
    SessionReport_sessionFeedback: "Session feedback",
    SessionReport_sessionMaterials_Assignments: "Session Materials & Assignments",
    SessionReport_instructions: "Instrucciones",
    SessionReport_open: "Abrir",
    SessionReport_invalidSession_Message: "Sorry, there is no report for this session",
    SessionReport_rateSession: "Califique su sesión",
    SessionReport_coachName: "¿Cómo fue tu sesión con",
    SessionRating_sessionDate: "Session date",
    SessionRating_sessionTime: "Session time",
    SessionRating_sessionDuration: "Session duration",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Rate your experience",
    SessionRating_whatWentWrong: "¿Qué ha ido mal?",
    SessionRating_content: "Contenido",
    SessionRating_technology: "Problemas técnicos",
    SessionRating_comment: "Deje un comentario",
    SessionRating_submit: "Enviar",
    SessionRating_remindMeLater: "Recordarme más tarde",
    SessionRating_close: "Close",
    SessionRating_completed: "Finished",
    sessionRating_sessionDetails_mins: "Minutes",
    // my schedule page translations
    myschedule_availability_abty_given: "We are working hard to match you with a trainer",
    myschedule_schedule: "My schedule",
    myschedule_availability_needAvl: "We need your availability to schedule your session",
    myschedule_availability_abty_not_given: "Provide / Modify your availability.",
    myschedule_statusCard_completed: "Session(s) completed",
    myschedule_statusCard_remaining: "Session(s) remaining",
    myschedule_statusCard_scheduled: "Session(s) to be scheduled",
    myschedule_statusCard_lost: "Lost (Late cancelled and absent)",
    myschedule_recentUpcoming_courseName: "Course name",
    myschedule_next_session: "Next session",
    myschedule_session_topic: "Session topic",
    myschedule_sessionDetails_communication: "Communication",
    myschedule_sessionDetails_allSessions: "All sessions",
    myschedule_sessionDetails_upcomingSessions: "Upcoming sessions",
    myschedule_sessionDetails_pastSessions: "Past sessions",
    myschedule_sessionDetails_teacher_name: "Teacher",
    myschedule_sessionDetails_sessions: "Number",
    myschedule_sessionDetails_dateTime: "Date / Time",
    myschedule_sessionDetails_date : "Date",
    myschedule_sessionDetails_time : "Time",
    myschedule_sessionDetails_durationText: "Duration",
    myschedule_sessionDetails_min: "Min",
    myschedule_reschedule_Title: "How to reschedule your session",
    myschedule_reschedule_InstrBegin: "Here's how you can reschedule your sessions with your trainer:",
    myschedule_reschedule_instr1a: "Check session details at the top",
    myschedule_reschedule_instr1b: "The date and time of your session are shown at the top.",
    myschedule_reschedule_instr2: "Trainer’s availability is displayed in green",
    myschedule_reschedule_instr3: "You will be able to see your trainer's availability. Available time slots are in green.",
    myschedule_reschedule_instr4: "Select a slot to reschedule",
    myschedule_reschedule_instr5: "To reschedule, click into the green area of available time slots for your chosen time.",
    myschedule_reschedule_next_instr1: "No suitable time slot",
    myschedule_reschedule_next_instr2: "Try to avoid cancellations, if you really cannot find a suitable time with your trainer, use the 'NO SUITABLE TIME SLOT' button to cancel your session. In this case your trainer will schedule this session for you or an administrator will assist you.",
    myschedule_reschedule_next_instr3: "Change your trainer",
    myschedule_reschedule_next_instr4a: "To change your trainer for one or more of your remaining sessions please use our",
    myschedule_reschedule_next_instr4b: "Contact form",
    myschedule_reschedule_next_instr4c: " and select {productname} + 'Change Trainer'.Please provide a reason why you would like to change your trainer.",
    myschedule_rechedule_next_info: "For further information regarding the rescheduling and cancellation options of trainer please visit our",
    myschedule_rechedule_next_faq: "FAQ portal.",
    myschedule_rechedule_next_noShow: "Don't show this info page again",
    myschedule_rechedule_next_done: "Done",
    myschedule_rechedule_skipButton: "Skip",
    myschedule_upcoming_joinNow: "Join now",
    myschedule_cancel_question: "Are you sure you want to cancel this session?",
    myschedule_cancel_button: "Cancel Session",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "There are no sessions for this course.",
    myschedule_sessionDuraion_minutes : "Minutes",
    myschedule_homepage_view :"View",
  myschedule_reschedule_button : "Reschedule",
    myschedule_no_teacher_title : "Teacher not assigned",
    myschedule_no_teacher_body : "No Sessions can be added at the moment (No teachers assigned). Please contact coach@globalenglish.com to continue with your program.",
    myschedule_status_lost :"Lost",
    myschedule_status_finished:"Finished",
    myschedule_status_completed:"Completed",
    myschedule_status_cancelled:"Cancelled",
    myschedule_status_inprogress:"In progress",
    myschedule_status_pending:"Pending",
    myschedule_status_active:"Active",
    myschedule_status_inplanning:"In planning",
   
    // my schedule page translations end
    // Progress page
    progress_title: "Progress",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note: "You must complete 70% or more of the coursework and sessions to be eligible for a certificate of completion.",
    progress_overall_card_title_prework:"Pre-work completed",
    progress_overall_card_title_homework:"Homework completed",
    progress_overall_card_title_session:"Session completed",
    progress_overall_card_title_certificate:"Certificate",
    progress_overall_card_title_skillsCompleted:"Habilidades completadas",
    progress_overall_card_title_badgesEarned:"Medallas ganadas",
    progress_overall_card_title_missionsPassed:"Missions passed",
    progress_overall_card_title_timeInReach:"Tiempo en Reach (HH:MM)",
    progress_noSubskill:"There is no subskill to show.",
    progress_tab_nodata:"No data to show here.",
    progress_percentCompleted: "percent completed",
    progress_subskill_preworkTitle: "Prework",
    progress_subskill_homeworkTitle: "Homework",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Completed",
    progress_subskill_sessionStatusNotCompleted: "Not completed",
    progress_subskill_sessionStatusAbsent: "Absent",
    progress_subskill_sessionStatusUpcoming: "Upcoming",
    progress_subskill_sessionStatusScheduled: "Scheduled",
    progress_subskill_sessionStatusScheduling: "Scheduling",
    progress_subskill_sessionStatusNoSessions: "No sessions",
    progress_subskill_sessionNoDate:"N/A",    
    progress_activity_tooltip_totaltime: "Total time",
    progress_activity_tooltip_activitiesCompleted: "Activities completed",
    progress_activity_tooltip_reachMissionsCompleted: "Reach missions completed",
    progress_activity_tooltip_timeinhhmm: "Time in HH:MM",
    progress_activity_tabDaily:"Daily",
    progress_activity_tabWeekly:"Weekly",
    progress_activity_tabMonthly:"Monthly",
    progress_activity_tabQuarterly:"Quarterly",
    progress_activity_tabYearly:"Yearly",
    progress_acitivity_Minutes: "Minutes",
    progress_acitivity_legend_selfpaced: "Self Paced Learning Time",
    progress_acitivity_legend_trainerLed: "Trainer Led Time",
    progress_acitivity_legend_recommended: "Recommended",
    progress_testresults_table_testname: "Test name",
    progress_testresults_table_scores: "Scores",
    progress_testresults_table_date: "Date",
    progress_testresults_info: "Your tests results will appear in 24 hours",
    progress_inprogress: "In progress",
    progress_totalscore: "Total score",
    progress_placedText: "Placed",
    progress_button_viewscore: "View detailed report",   
    progress_certificate_download_success : "Downloaded successfully",    
    progress_partText: "Part",    
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge:"Badge",    
    progress_badge_dialog_box_title: "In order to earn a certificate of completion, we require completion of 70% of the digital exercises.",
    progress_badge_dialog_box_golden : "A success score of 80% earns a gold badge",
    progress_badge_dialog_box_silver : "A success score between 70% and 79% earns a silver badge",
    progress_badge_dialog_box_bronze : "A success score between 50% to 69% earns a bronze badge",
    progerss_badge_dailog_box_digitalActivities : "The success score is calculated based on your performance and engagement with the online digital activities",
    progress_badge_dailog_box_liveSessions : "The success score is calculated based on your performance and engagement with the online digital activities and live sessions",
    
    //EO Progress page
    // Email templates start
    wcTitle: "Writing Center",
    guidelines: "Writing Guidelines",
    sampleDocs: "Sample Documents",
    wcGroup1: "Apologies",
    wcGroup2: "Complaints",
    wcGroup3: "Compliments",
    wcGroup4: "Congratulations",
    wcGroup5: "Documents",
    wcGroup6: "Invitations",
    wcGroup7: "Job Applications",
    wcGroup8: "Marketing and Sales",
    wcGroup9: "Meetings",
    wcGroup10: "Notices",
    wcGroup11: "Orders",
    wcGroup12: "Pricing Information",
    wcGroup13: "Requests",
    wcGroup14: "Thank You",
    wcTitle11: "Apology for a Delay in a Project",
    wcTitle12: "Apology for an Account Error",
    wcTitle13: "Apology for a Late Shipment",
    wcTitle14: "Apology for Delivery of Damaged Goods",
    wcTitle15: "Apology for Missing a Meeting",
    wcTitle21: "General Complaint",
    wcTitle22: "Complaint about a Problem with a Product",
    wcTitle23: "Complaint about an Overcharge to an Account",
    wcTitle31: "Compliment to a Colleague on a Project",
    wcTitle32: "Compliment about Customer Service",
    wcTitle33: "Compliment about a Product",
    wcTitle41: "Congratulations on a Promotion (Formal)",
    wcTitle42: "Congratulations on a Promotion (Informal)",
    wcTitle43: "Congratulations on a Personal Event",
    wcTitle51: "Requested Document",
    wcTitle52: "Order Form or Purchase Order",
    wcTitle53: "Invoice",
    wcTitle61: "Invitation to a Social Event",
    wcTitle62: "Invitation to a Business Event",
    wcTitle63: "Accepting an Invitation",
    wcTitle64: "Declining an Invitation",
    wcTitle65: "Canceling a Business Event",
    wcTitle71: "Acknowledgement of Receipt of Application",
    wcTitle81: "Announcement of a New Product",
    wcTitle82: "Announcement of a New Area Representative",
    wcTitle83: "New Product Demo",
    wcTitle84: "Change of Billing Address",
    wcTitle85: "Follow-Up after a First Sales Meeting",
    wcTitle86: "New Customer Welcome",
    wcTitle87: "Holiday Message to Stockholders or Customers",
    wcTitle91: "Proposing a Time for a Meeting",
    wcTitle92: "Confirming a Meeting",
    wcTitle93: "Postponing a Meeting",
    wcTitle94: "Canceling a Meeting",
    wcTitle95: "Summarizing a Meeting",
    wcTitle101: "Suspended Account",
    wcTitle102: "Request to Close an Account",
    wcTitle111: "Confirming an Order",
    wcTitle112: "Providing Shipping Confirmation",
    wcTitle113: "Canceling an Order",
    wcTitle114: "Changing an Order",
    wcTitle115: "Acknowledging a Delivery",
    wcTitle121: "Providing Pricing Information",
    wcTitle122: "Accepting a Price Quotation",
    wcTitle123: "Rejecting a Price Quotation",
    wcTitle131: "Request for Clarification of Information",
    wcTitle132: "Request for Information about a Product",
    wcTitle133: "Request for Information about a Service",
    wcTitle141: "General Thanks",
    guideGroup1: "Common Writing Problems",
    guideGroup2: "General Business Communication",
    guideGroup3: "Business Documents",
    guideTitle11: "Reasons for Unclear Writing",
    guideTitle12: "Basic Writing Errors",
    guideTitle13: "Problems with Verbs",
    guideTitle21: "Directness in Business Communication",
    guideTitle22: "Language for Sales and Marketing",
    guideTitle23: "Everyday Business Idioms",
    guideTitle31: "Effective Emails",
    guideTitle32: "Presentations: General Tips",
    guideTitle33: "Presentations: Effective Openings",
    backIndex: "Back to Index",
    copyText: "Copy Text",
    exportEmail: "Export Text to Email",
    Blob: "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    OpenInEmail: "Open in email",
    Quote1: "There are currently 3.3 billion email accounts in the world.",
    Quote1By: "Mashable",
    Quote2: "Email generates nearly a 2X return compared to other channels.",
    Quote2By: "Direct Marketing Lead",
    Quote3: "3.5 million emails are sent per second.",
    Quote3By: "Marketing Lead",
    SelectACategory: "Select a category",
    WatchTutorial: "Watch a video tutorial",
    String: "Quote1",
    NoAm: "North America",
    Cenam: "Central America",
    SoAm: "Sudamérica",
    EUR: "Europa",
    ASIA: "Asia",
    CenASIA: "Central Asia",
    SoEASIA: "South East Asia",
    MidEAST: "Middle East",
    AFR: "África",
    AUST: "Australia",
    Cana: "Canadá",
    Mexi: "México",
    Uniteds: "Estados Unidos",
    CostaR: "Costa Rica",
    DomRep: "Dominican Republic",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panama",
    TriniTob: "Trinidad & Tobago",
    Arge: "Argentina",
    Braz: "Brasil",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Colombia",
    Peru: "Peru",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "Bélgica",
    Bulg: "Bulgaria",
    Croatia: "Croatia",
    Czec: "República Checa",
    Denm: "Dinamarca",
    Finl: "Finlandia",
    Fran: "Francia",
    Germ: "Alemania",
    Greec: "Greece",
    Hung: "Hungría",
    Icel: "Iceland",
    Irel: "Irlanda",
    Ital: "Italia",
    Lith: "Lithuania",
    Luxem: "Luxembourg",
    Neth: "Países Bajos",
    Norw: "Noruega",
    Pola: "Polonia",
    Port: "Portugal",
    Roma: "Rumanía",
    Russ: "Federación Rusa",
    Serb: "Serbia",
    Slovakia: "Slovakia",
    Slovania: "Slovenia",
    Spai: "España",
    Swed: "Suecia",
    Swit: "Suiza",
    Turk: "Turquía",
    Ukra: "Ucrania",
    Unitedk: "Reino Unido",
    Chin: "China",
    Hong: "Hong Kong",
    Indi: "La India",
    Japa: "Japón",
    Mongo: "Mongolia",
    Pakis: "Pakistan",
    SoKore: "South Korea",
    SriLan: "Sri Lanka",
    Taiw: "Taiwán",
    Afgh: "Afghanistan",
    Azer: "Azerbaijan",
    Kaza: "Kazajistán",
    Camb: "Cambodia",
    Indo: "Indonesia",
    Malay: "Malasia",
    Phil: "Filipinas",
    Sing: "Singapur",
    Thai: "Tailandia",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Iraq",
    Isra: "Israel",
    Jor: "Jordan",
    Kuw: "Kuwait",
    Leb: "Lebanon",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Saudi Arabia",
    UAE: "United Arab Emirates",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "Egipto",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Morocco",
    Mozam: "Mozambique",
    Nige: "Nigeria",
    SoAfr: "South Africa",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "Australia",
    NewZea: "New Zealand",
    culturenotes_mainintrotext: "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    culturenotes_useculturalinfo: "Use our cultural information to prepare for important meetings with customers and coworkers around the world.",
    culturenotes_topicfamiliarize: "Familiarize yourself with customs, such as business hours, dining out, gift giving, etc. in other cultures.",
    culturenotes_topiclearnculture: "Learn about cultural practices, cultural differences, and local manners to avoid making cultural mistakes.",
    culturenotes_tmaworldtext: "Country reports are developed by our partner TMA World and are available in downloadable PDF versions.",
    culturenoteslocation_viewbytopic: "View by topic",
    culturenoteslocation_viewbycountry: "View by country",
    dailyNewsFeed_resources: "Resources",
    dailyNewsFeed_daily_News: "Daily news feed",
    dailyNewsFeed_newsfeedoftheday: "News feed of the day",
    dailyNewsFeed_feedcontent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Sorry, we are unable to fetch your daily news feed, please try again after sometime.",
    dailyNewsFeed_viewMoreCategories: "View more categories",    
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Page not found.",
    error_contact_csm: "Please contact your Customer Success Manager for help.",
    error_under: "Under",
    error_maintenance: "maintenance",
    error_under_maintenance: "Our site is currently undergoing scheduled maintenance.",
    error_inconvenience: "We're sorry for any inconvenience.",
    error_tryagain: "Please try again later.",
    error_tryagainMins: "Please try again in",
    error_minutes: "minute(s).",
    error_hours : "hour(s)",
    error_oops: "Oops!",
    error_permission_denied: "You don't have permission to view this page!",
    error_link_home: "home page",
    error_contact_admin: "Please contact your Learnship Administrator for help.",
    error_sorry: "We're Sorry.",
    error_load: "There was a problem loading this page.",
    error_clear_cache: "Please clear your browser's cache, check your internet connection, and try again.",
    error_contact: "Please contact our",
    error_contact_cst: "customer support team",
    error_forhelp: "for help.",
    error_having_trouble: "Still having trouble?",
    //Accents and Dialects Dropdowns
    AF: "África",
    AS: "Asia",
    AU: "Australia y Oceanía",
    CA: "Caribe",
    CE: "Centroamérica",
    EU: "Europa",
    MI: "Oriente Medio",
    NO: "Norteamérica",
    SO: "Sudamérica",
    CAMER: "Camerún",
    EGYPT: "Egipto",
    ETHIO: "Etiopía",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Sudáfrica",
    TANZA: "Tanzania",
    AFGHA: "Afganistán",
    CHINA: "China",
    INDIA: "La India",
    INDON: "Indonesia",
    JAPAN: "Japón",
    KAZAK: "Kazajistán",
    LEBAN: "El Líbano",
    MONGO: "Mongolia",
    NORTH: "Vietnam del Norte",
    PAKIS: "Pakistán",
    PHILI: "Filipinas",
    SINGA: "Singapur",
    KOREA: "Corea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwán",
    THAIL: "Tailandia",
    TURKM: "Turkmenistán",
    AUSTR: "Australia",
    FIJI_: "Fiji",
    NEW_Z: "Nueva Zelandia",
    BERMU: "Bermudas",
    CUBA_: "Cuba",
    HAITI: "Haití",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (francesa)",
    TRINI: "Trinidad y Tobago",
    AUSTRI: "Austria",
    BELAR: "Bielorrusia",
    BELGI: "Bélgica",
    BULGA: "Bulgaria",
    CYPRU: "Chipre",
    CZECH: "República Checa",
    DENMA: "Dinamarca",
    ENGLA: "Inglaterra",
    FINLA: "Finlandia",
    FRANC: "Francia",
    GEORG: "Georgia",
    GERMA: "Alemania",
    GREEC: "Grecia (Hellas)",
    HUNGA: "Hungría",
    IRELA: "Irlanda",
    ITALY: "Italia",
    MACED: "Macedonia",
    NETHE: "Países Bajos",
    NORTHI: "Irlanda del Norte",
    POLAN: "Polonia",
    ROMAN: "Rumanía",
    RUSSI: "Federación Rusa",
    SCOTL: "Escocia",
    SPAIN: "España",
    SWEDE: "Suecia",
    SWITZ: "Suiza",
    TURKE: "Turquía",
    UKRAI: "Ucrania",
    WALES: "Gales",
    IRAN_: "Irán",
    IRAQ_: "Irak",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Arabia Saudita",
    SYRIA: "Siria",
    CANAD: "Canadá",
    MEXIC: "México",
    ARGEN: "Argentina",
    BRAZI: "Brasil",
    CHILE: "Chile",
    COLOM: "Colombia",
    PARAG: "Paraguay",
    PERU_: "Perú",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Acentos y dialectos del inglés",
    US:"Estados Unidos de América",
    ALABA:"Alabama",
    ALASK:"Alaska",
    ARKAN:"Arkansas",
    CALIF:"California",
    FLORI:"Florida",
    GEORG_US:"Georgia",
    HAWAI:"Hawai",
    ILLIN:"Illinois",
    INDIA_US:"Indiana",
    KANSA:"Kansas",
    KENTU:"Kentucky",
    LOUIS:"Luisiana",
    MAINE:"Maine",
    MARYL:"Maryland",
    MASSA:"Massachusetts",
    MICHI:"Michigan",
    MINNE:"Minnesota",
    MISSI:"Misisippi",
    MISSO:"Misuri",
    MONTA:"Montana",
    NEBRA:"Nebraska",
    NEW_H:"Nuevo Hampshire",
    NEW_J:"Nueva Jersey",
    NEW_Y:"Nueva York",
    NCARO:"Carolina del Norte",
    NDAKO:"Dakota del Norte",
    OHIO_:"Ohio",
    OKLAH:"Oklahoma",
    PENNS:"Pensilvania",
    SOUTH_US:"Carolina del Sur",
    TENNE:"Tennessee",
    TEXAS:"Texas",
    VIRGI:"Virginia",
    WEST_:"Virginia Occidental",
    WISCO:"Wisconsin",
    manager_email_managertext: "Your company has requested a monthly report for your manager indicating your progress in Learnship. Please provide your manager’s email address below.",
     // survey and notification
  notification_description_plural : "{days} days remaining to complete the survey. You must complete it by {date}.",
  notification_description_singular : "1 day remaining to complete the survey. You must complete it by {date}.",
  notification_maintenance_message : "Halo will be undergoing scheduled maintenance on {date} at {time}.",
  //renewal
  renewal_welcome : "Welcome back to Learnship!",
  renewal_text : "Your Learnship license will expire on {date}. To continue improving your Business English Communication skills, renew your license today. Your study plan and all of your work will be saved and you will continue at your current level.",
  renewal_later : "Please ask me later",
  renewal_affirmative : "YES, I want to renew my license.",
  renewal_negative : "NO, I do not want to renew my license.",
  renewal_yes : "YES",
  renewal_no : "NO",
  courselevel: "Course level",
  currentunit: "Current unit",
  upcomingsession: "Upcoming session",
  viewschedule: "View Schedule",
    currentskills: "Skills",
    currentsubskills: "Sub-skills",

    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading: "Practice your conversation skills with a teacher and other learners in our online classroom!",
    twt_instructions: "Instructions",
    twt_faq: "FAQs",
    twt_select_sessions: "Select your sessions",
    twt_view_schedule_title: "View schedule and add to calendar",
    twt_next_week: "Next week",
    twt_previous_week: "Previous week",
    twt_add_to_calendar: "Add to calendar",
    twt_view_more: "View more",
    twt_topic: "Topic",
    twt_topic_unavailable: "Topic time not available",
    twt_class_policy: "Política de las clases",
    twt_class_policy_title: "Normas y directrices de Hable con el profesor",
    twt_class_policy_subHeading: "Las siguientes políticas y pautas son importantes para garantizar que su experiencia en Hable con el Profesor (TWT) sea educativa y agradable. Por favor léalas cuidadosamente.",
    twt_class_policy_list01: "Usted podrá ingresar a una sesión por semana*. Nuestro salón virtual tiene un límite de 8 estudiantes como máximo. Mejores prácticas: Llegue cerca al horario en que inicia la sesión. Los salones virtuales de TWT están listos para que entre solo durante los 10 primeros minutos de cada sesión. Por ejemplo, una sesión inicia a las 9:00, estará disponible para ingresar hasta las 9:10. Después de los primeros 10 minutos, usted ya no podrá unirse a la sesión. Limitado o sin límite de accesos dependen del tipo de licencia que usted tenga.",
    twt_class_policy_list02_sub1: "Cuando usted ingrese al salón, escriba su nombre, ciudad, país, y nivel en la caja de Chat.",
    twt_class_policy_list02_sub2: `Por ejemplo: "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6."`,
    twt_class_policy_list02_sub3: "El instructor activará su micrófono y aparecerá el icono de micrófono.",
    twt_class_policy_list03: "Si usted tiene un problema técnico, por favor contacte a nuestro equipo de Soporté. Haga clic en Ayuda en la parte superior de cualquier página donde se encuentre dentro del servicio y envíe el problema que presenta escribiendo, o usted puede hablar con un representante del equipo de Soporte utilizando la herramienta de Chat localizada en la página de Learnship One. Por favor no le pida al profesor del salón virtual por ayuda técnica.",
    twt_class_policy_list04: "Hay 4 niveles para las sesiones de Hable con el Profesor (TWT): Principiantes, Intermedios, Avanzados y Todos los niveles. Usted debe ir a la sesión que apropiada para sus habilidades en el inglés. Por ejemplo, si usted está en alguno de los niveles 0-3, requiere ir a una sesión de Principiantes. Cualquier estudiante (en cualquier nivel) puede atender las sesiones de Todos los niveles. Si usted logra unirse a una sesión de TWT que no es la más apropiada para sus habilidades en el inglés, su instructor le informara que usted no está en la sesión correcta. Usted tendrá dos opciones: Puede decirle a su instructor que quiere quedarse y quedarse a solo escuchar, por ejemplo, usted no podrá participar (hablar); o usted puede dejar la sesión y unirse más tarde a otra sesión en su nivel correcto.",
    twt_class_policy_list05: "Si usted desea escuchar en una sesión en línea sin querer hablar, lo puede hacer, una hora a la semana. Después de eso, usted ya podrá participar hablando durante la sesión. Usted podrá escuchar sin hablar un total de 4 sesiones al año. Si rebase ese límite, y no quiere participar (hablando) durante la sesión, se terminará dicha sesión.",
    twt_class_policy_list06: "Si quiere escuchar una clase en línea sin participar oralmente en ella, puede hacerlo durante una hora a la semana. Una vez trascurrido ese tiempo, deberá participar en ella activamente. Puede escuchar un total de cuatro clases al año sin tener que participar en ellas. Si supera este límite y no comienza a participar en la clase, se cerrará su sesión.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message: "You have already joined this session from another device. Please logout before joining from current device.",
    twt_max_capacity_error_message: "Sorry you cannot join this session because it has reached maximum capacity. Please join another session",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?"
  },
};
